import { render, staticRenderFns } from "./startCarReplace.vue?vue&type=template&id=5e98b22b&scoped=true"
import script from "./startCarReplace.vue?vue&type=script&setup=true&lang=js"
export * from "./startCarReplace.vue?vue&type=script&setup=true&lang=js"
import style0 from "./startCarReplace.vue?vue&type=style&index=0&id=5e98b22b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e98b22b",
  null
  
)

export default component.exports